import { memo, ReactElement } from 'react';
import useStorageSync from '../../../../hooks/useStorageSync';

const AppSetup = memo((): ReactElement | null => {
  useStorageSync();
  return null;
});
export default AppSetup;
